<div class="bboard-welcome-img on" [ngClass]="{'off':!blackboardStateModel.isOn}" >
<!--[ngClass]="{'off':blackboardStateModel?.isActive}"-->
  <span class="bboard-welcome-text"> Welcome to the Russian School of Mathematics! </span>
</div>

<div id="bbContainer" style="border-color: rgb(255, 0, 0);">
  <div style="height: 0; background-color: rgb(238, 249, 248); display: block;">
    <!--currentUser?.role==Role.TEACHER-->
    <input type="button" value="" class="board-side-welcome" title="Blackboard on/off"
           *ngIf="localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT"
           (click)="toggleBlackboard()" style="display: inline;">
    <!--&& currentUser.role===Role.TEACHER-->
    <div id="bb-toolbar" class="bb-tools" *ngIf="(localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT) && blackboardStateModel.isOn">
      <input type="button" value="" class="board-side-erase" title="Clear" (click)="clearEventHandler()">
      <input type="button" value="" class="board-side-eraser" title="Eraser" [ngClass]="{'blk_btn_selected': selectedTool === tools.ERASER}" (click)="selectBlackboardTool(1)">
      <input type="button" value="T" class="board-text-tool" title="Text mode" [ngClass]="{'blk_btn_selected': selectedTool === tools.TEXT}" (click)="selectBlackboardTool(2)">
      <input type="button" value="" class="board-side-pointer" title="Pointer" [ngClass]="{'blk_btn_selected': selectedTool === tools.POINTER}" (click)="selectBlackboardTool(3)">
    </div>
  </div>


  <textarea [(ngModel)]="text"
            #bbTextArea
            id="bbTextArea"
            maxlength="1800"
            [ngStyle]="{'pointer-events': selectedTool === tools.TEXT ? 'unset':'none'}"
             style="position: absolute; z-index: 8; background-color: rgba(0, 0, 0, 0); color: rgb(255, 255, 255);
                    resize: none; border:none; outline: none; pointer-events: unset; font-family: Arial, Calibri, sans-serif; font-size: 16px;
                    overflow: hidden; line-height: 28px; margin-left: 5px; transform-origin: 0 0; transform: scale(1); width: 787px;
                    height: 310px;"
            (copy)="utilService.safeCopy($event)"
            (cut)="utilService.safeCut($event)"
            (paste)="utilService.safePaste($event)">
  </textarea>

  <canvas id="blackCanvas" width="817" height="310"
          style="display: block; background-color: rgb(34, 34, 34); width: 817px; height: 310px;"></canvas>
</div>

<div id="bbPointerContainer" [hidden]="pointer.isHidden">
  <svg id="bbPointer" width="46" height="46" viewBox="0 0 46 46">
    <circle r="20" cx="23" cy="23" fill="none" stroke-width="3" stroke="#7efca099" />
    <circle r="20" cx="23" cy="23" fill="#0da83977" />
  </svg>
</div>

